<template>
    <a-layout-content class="overflow-hidden">
        <div class="filter-panel">
            <a-row>
                <a-col :span="24" class="other-filter">
                    <div class="mr-20">关键字:</div>
                    <a-input class="mr-20" placeholder="关键字" style="width: 360px" v-model="keyword" />
                    <div class="mr-20">物料名称:</div>
                    <a-select class="mr-20" style="width: 240px" v-model="materialName" placeholder="物料名称">
                        <a-select-option v-for="o in materials" :value="o" :key="o">{{ o }}</a-select-option>
                    </a-select>
                    <div class="mr-20">检测机构:</div>
                    <a-select class="mr-20" style="width: 80px" v-model="deptId" placeholder="检测机构">
                        <a-select-option v-for="o in depts" :value="o.deptId" :key="o.deptId">{{ o.deptName }}</a-select-option>
                    </a-select>

                    <a-button class="mr-20 view-btn large" html-type="submit" @click="getList(true)">搜索</a-button>
                    <a-button class="mr-20 view-btn large" html-type="submit" @click="reset">重置</a-button>
                </a-col>
            </a-row>
        </div>
        <a-divider></a-divider>
        <div class="flex-container filter-panel filter-panel2">
            <sub-title>数据列表</sub-title>
            <ul class="handle-list" style="margin: -11px 0">
                <li class="handle-item" @click="expandAll">
                    <span v-if="this.expandedRowKeys.length == 0">
                        <a-icon type="plus-square" theme="twoTone" two-tone-color="#52c41a" />
                    </span>
                    <span v-else>
                        <a-icon type="minus-square" theme="twoTone" two-tone-color="#52c41a" />
                    </span>&nbsp;
                    <a href="javascript:;">{{ this.expandedRowKeys.length == 0 ? "展开" : "收起" }}</a>
                </li>
                <li class="handle-item" @click="exportData">
                    <a-icon type="check-circle" theme="twoTone" two-tone-color="#52c41a" />&nbsp;
                    <a href="javascript:;">导出</a>
                </li>
            </ul>
        </div>
        <a-divider></a-divider>
        <div class="div-inline">
            <div>
                <a-tabs default-active-key="0" @change="callback" tab-position="top">
                    <a-tab-pane key="9528" :tab="tabTitle1">
                        <a-table :columns="columns" :dataSource="list" :rowKey="(record) => record.b_id"
                            :loading="loading" :scroll="{ x: 1500, y: 800 }"
                            v-if="list && list.length > 0 && selectTab == '9528'" :pagination="pagination"
                            @change="onPageChange"
                            :row-selection="{ type: 'checkbox', selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                            :expandedRowKeys.sync="expandedRowKeys" :rowClassName="rowClass" @expand="expandMe">
                            <template slot="showTitle" slot-scope="text, record" ellipsis="...">
                                <div :title="text" style="white-space: pre-wrap;">{{ text }}</div>
                            </template>

                            <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
                            <table width="95%">
                                <tr :class="rowClass(record)">
                                    <td width="23%">
                                        <span class="childCss">计划发（到）货时间：</span>
                                        <strong>
                                            {{ moment(record.b_plan_start).format("YYYY-MM-DD") }}
                                            ~{{ moment(record.b_plan_end).format("YYYY-MM-DD") }}
                                        </strong>
                                    </td>
                                    <td width="7%">
                                        <span class="childCss">数量：</span><strong>{{ record.b_num }}</strong>
                                    </td>
                                    <td width="25%">
                                        <span class="childCss">地点：</span><strong>{{ record.b_address }}</strong>
                                    </td>
                                    <td width="9%">
                                        <span class="childCss">联系人：</span><strong>{{ record.b_linkman }}</strong>
                                    </td>
                                    <td width="14%">
                                        <span class="childCss">联系电话：</span><strong>{{ record.b_linkphone }}</strong>
                                    </td>
                                    <td>
                                        <span class="childCss">备注说明：</span><strong>{{ record.b_remark }}</strong>
                                    </td>
                                    <td>
                                        <!-- <template slot="operation" slot-scope="text, record"> -->
                                        <a @click="checkOne(1, record)" href="javascript:;">送样填报</a>
                                        <!-- </template> -->
                                    </td>
                                </tr>
                            </table>
                            </p>

                            <template slot="showStatus" slot-scope="text, record">
                                <div :title="text">{{ getStatus(record.b_status) }}</div>
                            </template>
                        </a-table>

                    </a-tab-pane>
                    <a-tab-pane key="9527" :tab="tabTitle2">
                        <a-table :columns="columns" :dataSource="list" :rowKey="(record) => record.b_id"
                            :loading="loading" :scroll="{ x: 1500, y: 800 }"
                            v-if="list && list.length > 0 && selectTab == '9527'" :pagination="pagination"
                            @change="onPageChange"
                            :row-selection="{ type: 'checkbox', selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                            :expandedRowKeys.sync="expandedRowKeys" :rowClassName="rowClass" @expand="expandMe">
                            <template slot="showTitle" slot-scope="text, record" ellipsis="...">
                                <div :title="text" style="white-space: pre-wrap;">{{ text }}</div>
                            </template>

                            <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
                            <table width="95%" border="1">
                                <tr :class="rowClass(record)">
                                    <td width="23%">
                                        <span class="childCss">计划发（到）货时间：</span>
                                        <strong>
                                            {{ moment(record.b_plan_start).format("YYYY-MM-DD") }}
                                            ~{{ moment(record.b_plan_end).format("YYYY-MM-DD") }}
                                        </strong>
                                    </td>
                                    <td width="13%">
                                        <span class="childCss">数量：</span><strong>{{ record.b_num }}</strong>
                                    </td>
                                    <td width="20%">
                                        <span class="childCss">地点：</span><strong>{{ record.b_address }}</strong>
                                    </td>
                                    <td width="13%">
                                        <span class="childCss">联系人：</span><strong>{{ record.b_linkman }}</strong>
                                    </td>
                                    <td width="14%">
                                        <span class="childCss">联系电话：</span><strong>{{ record.b_linkphone }}</strong>
                                    </td>
                                    <td rowspan="2">
                                        <span class="childCss">备注说明：</span><strong>{{ record.b_remark }}</strong>
                                    </td>
                                    <td rowspan="2">
                                        <!-- <template slot="operation" slot-scope="text, record"> -->
                                        <span v-if="record.b_check_result == 0">
                                            <a @click="checkOne(2, record)" href="javascript:;">报告填报</a>
                                        </span>
                                        <span v-else class="childCss">
                                            报告填报
                                        </span>
                                    </td>
                                </tr>
                                <tr :class="rowClass(record)">
                                    <td><span class="childCss">收样日期：</span><strong>{{ record.b_received_at }}</strong>
                                    </td>
                                    <td><span class="childCss">收样照片：</span>
                                        <span v-for="(o, idx) in getUrls(record.b_received_url)" :key="idx">
                                            <a :href="o" target="_blank">图片_{{ idx + 1 }}</a>
                                        </span>
                                    </td>
                                    <td><span class="childCss">收样人：</span><strong>{{ record.b_receiver }}</strong></td>
                                    <td><span class="childCss">抽检方式：</span><strong>{{ record.b_check_method }}</strong>
                                    </td>
                                    <td><span class="childCss">抽检人员：</span><strong>{{ record.b_checker }}</strong></td>
                                </tr>
                                <tr :class="rowClass(record)">
                                    <td><span class="childCss">抽检时间：</span><strong>{{ record.b_check_time }}</strong>
                                    </td>
                                    <td><span class="childCss">检测报告：</span>
                                        <span v-for="(o, idx) in getUrls(record.b_report_url)" :key="idx">
                                            <a :href="o" target="_blank">报告_{{ idx + 1 }}</a>
                                        </span>
                                    </td>
                                    <td><span class="childCss">检测结果：</span><strong>{{
                                            record.b_check_result == 1 ? '合格' : (record.b_check_result == 2 ? '不合格' :
                                                '')
                                    }}</strong>
                                    </td>
                                    <td><span class="childCss">报告编号：</span><strong>{{
                                            record.b_report_no
                                    }}</strong>
                                    </td>
                                    <td colspan="2"><span class="childCss">备注说明：</span><strong>{{ record.b_report_remark
                                    }}</strong>
                                    </td>
                                    <!-- <td><strong>{{ record.assignHN==1?'指定汉南':''}}</strong>
                                    </td> -->
                                </tr>
                            </table>
                            </p>

                            <template slot="showStatus" slot-scope="text, record">
                                <div :title="text">{{ getStatus(record.b_status) }}</div>
                            </template>
                        </a-table>
                    </a-tab-pane>
                    <a-tab-pane key="9529" :tab="tabTitle3">
                        <a-table :columns="columns" :dataSource="list" :rowKey="(record) => record.b_id"
                            :loading="loading" :scroll="{ x: 1500, y: 800 }"
                            v-if="list && list.length > 0 && selectTab == '9529'" :pagination="pagination"
                            @change="onPageChange"
                            :row-selection="{ type: 'checkbox', selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                            :expandedRowKeys.sync="expandedRowKeys" :rowClassName="rowClass2" @expand="expandMe">
                            <template slot="showTitle" slot-scope="text, record" ellipsis="...">
                                <div :title="text" style="white-space: pre-wrap;">{{ text }}</div>
                            </template>

                            <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
                            <table width="95%" border="1">
                                <tr :class="rowClass2(record)">
                                    <td width="23%">
                                        <span class="childCss">计划发（到）货时间：</span>
                                        <strong>
                                            {{ moment(record.b_plan_start).format("YYYY-MM-DD") }}
                                            ~{{ moment(record.b_plan_end).format("YYYY-MM-DD") }}
                                        </strong>
                                    </td>
                                    <td width="13%">
                                        <span class="childCss">数量：</span><strong>{{ record.b_num }}</strong>
                                    </td>
                                    <td width="20%">
                                        <span class="childCss">地点：</span><strong>{{ record.b_address }}</strong>
                                    </td>
                                    <td width="13%">
                                        <span class="childCss">联系人：</span><strong>{{ record.b_linkman }}</strong>
                                    </td>
                                    <td width="14%">
                                        <span class="childCss">联系电话：</span><strong>{{ record.b_linkphone }}</strong>
                                    </td>
                                    <td rowspan="2">
                                        <span class="childCss">备注说明：</span><strong>{{ record.b_remark }}</strong>
                                    </td>
                                </tr>
                                <tr :class="rowClass2(record)">
                                    <td><span class="childCss">收样日期：</span><strong>{{ record.b_received_at }}</strong>
                                    </td>
                                    <td><span class="childCss">收样照片：</span>
                                        <span v-for="(o, idx) in getUrls(record.b_received_url)" :key="idx">
                                            <a :href="o" target="_blank">图片_{{ idx + 1 }}</a>
                                        </span>
                                    </td>
                                    <td><span class="childCss">收样人：</span><strong>{{ record.b_receiver }}</strong></td>
                                    <td><span class="childCss">抽检方式：</span><strong>{{ record.b_check_method }}</strong>
                                    </td>
                                    <td><span class="childCss">抽检人员：</span><strong>{{ record.b_checker }}</strong></td>
                                </tr>
                                <tr :class="rowClass2(record)">
                                    <td><span class="childCss">抽检时间：</span><strong>{{ record.b_check_time }}</strong>
                                    </td>
                                    <td><span class="childCss">检测报告：</span>
                                        <span v-for="(o, idx) in getUrls(record.b_report_url)" :key="idx">
                                            <a :href="o" target="_blank">报告_{{ idx + 1 }}</a>
                                        </span>
                                    </td>
                                    <td><span class="childCss">检测结果：</span><strong>{{
                                            record.b_check_result == 1 ? '合格' : (record.b_check_result == 2 ? '不合格' :
                                                '')
                                    }}</strong>
                                    </td>
                                    <td><span class="childCss">报告编号：</span><strong>{{
                                            record.b_report_no
                                    }}</strong>
                                    </td>
                                    <td colspan="1"><span class="childCss">备注说明：</span><strong>{{ record.b_report_remark
                                    }}</strong>
                                    </td>
                                    <!-- <td><strong>{{ record.assignHN==1?'指定汉南':''}}</strong>
                                    </td> -->
                                </tr>
                            </table>
                            </p>

                            <template slot="showStatus" slot-scope="text, record">
                                <div :title="text">{{ getStatus(record.b_status) }}</div>
                            </template>
                        </a-table>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>
        <!-- 列表表格 -->

        <!-- 新增/编辑 -->
        <a-modal centered title="送样填报" v-model="edit_visible" v-if="edit_visible" :zIndex="2" width="720px"
            :maskClosable="false" @ok="save_handle">
            <a-form class="modal-form" :form="form">
                <a-form-item label="b_id" hidden :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                    <a-input placeholder="b_id" :rows="4" v-decorator="[
                        'id',
                        {
                            initialValue: testObj && testObj.b_id,
                            rules: [{ required: true, message: 'b_id不能为空' }],
                        },
                    ]" />
                </a-form-item>
                <a-form-item label="收样日期" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                    <a-date-picker placeholder="收样日期" :rows="4" v-decorator="[
                        'received_at',
                        {
                            initialValue: testObj && (testObj.received_at ? moment(testObj.received_at) : null),
                            rules: [{ required: true, message: '收样日期不能为空' }],
                        },
                    ]" show-time format="YYYY-MM-DD" value-format="YYYY-MM-DD" />
                </a-form-item>
                <a-form-item label="收样照片" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                    <a-upload action="/api/api/common/upload" list-type="picture" :file-list="fileList"
                        @change="handleChange" :beforeUpload="beforeUpload" :data="params">
                        <a-button>
                            <a-icon type="upload" />上传
                        </a-button>
                    </a-upload>
                </a-form-item>
                <a-form-item label="收样人" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                    <a-input placeholder="收样人" disabled :rows="4" v-decorator="[
                        'receiver',
                        {
                            initialValue: testObj && testObj.receiver,
                            rules: [{ required: true, message: '收样人不能为空' }],
                        },
                    ]" />
                </a-form-item>
                <a-form-item label="抽检方式" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                    <a-select placeholder="抽检方式" v-decorator="[
                        'check_method',
                        {
                            initialValue: testObj && testObj.check_method,
                            rules: [{ required: true, message: '抽检方式不能为空' }]
                        },
                    ]">
                        <a-select-option v-for="o in check_methods" :value="o" :key="o">{{ o }}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="抽检人员" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                    <a-input placeholder="抽检人员" :rows="4" v-decorator="[
                        'checker',
                        {
                            initialValue: testObj && testObj.checker,
                            rules: [{ required: true, message: '抽检人员不能为空' }],
                        },
                    ]" />
                </a-form-item>
                <!-- <a-form-item label="指定汉南" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                    <a-checkbox placeholder="指定汉南" v-decorator="[
                        'assignHN',
                        {
                            initialValue: testObj && testObj.assignHN
                        },
                    ]" />
                </a-form-item> -->
            </a-form>
        </a-modal>

        <!-- 报告填报 -->
        <a-modal centered title="报告填报" v-model="edit_visible2" v-if="edit_visible2" :zIndex="2" width="720px"
            :maskClosable="false" @ok="save_handle2">
            <a-form class="modal-form" :form="form">
                <a-form-item label="b_id" hidden :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                    <a-input placeholder="b_id" :rows="4" v-decorator="[
                        'id',
                        {
                            initialValue: testObj && testObj.b_id,
                            rules: [{ required: true, message: 'b_id不能为空' }],
                        },
                    ]" />
                </a-form-item>
                <a-form-item label="抽检时间" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                    <a-date-picker placeholder="抽检时间" :rows="4" v-decorator="[
                        'check_time',
                        {
                            initialValue: testObj && (testObj.check_time ? moment(testObj.check_time) : null),
                            rules: [{ required: true, message: '抽检时间不能为空' }],
                        },
                    ]" show-time format="YYYY-MM-DD" value-format="YYYY-MM-DD" />
                </a-form-item>
                <a-form-item label="检测报告" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                    <a-upload action="/api/api/common/upload" list-type="picture" :file-list="fileList2"
                        @change="handleChange2" :beforeUpload="beforeUpload" :data="params">
                        <a-button>
                            <a-icon type="upload" />上传
                        </a-button>
                    </a-upload>
                </a-form-item>
                <a-form-item label="报告编号" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                    <a-input placeholder="报告编号" :rows="4" v-decorator="[
                        'report_no',
                        {
                            initialValue: testObj && testObj.report_no
                        },
                    ]" />
                </a-form-item>
                <a-form-item label="检测结果" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                    <a-select placeholder="检测结果" v-decorator="[
                        'check_result',
                        {
                            initialValue: testObj && testObj.check_result,
                            rules: [{ required: true, message: '抽检方式不能为空' }]
                        },
                    ]">
                        <a-select-option v-for="o in check_results" :value="o.value" :key="o.title">{{ o.title }}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="备注说明" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                    <a-input placeholder="备注说明" :rows="4" v-decorator="[
                        'report_remark',
                        {
                            initialValue: testObj && testObj.report_remark,
                        },
                    ]" />
                </a-form-item>
            </a-form>
        </a-modal>
    </a-layout-content>
</template>
<script>
import SubTitle from "@/components/common/subTitle";
import { Divider, Modal } from "ant-design-vue";
import { get_check_list, sendInvoice, reportInvoice, exportData } from "@/api";
import { getUserInfo, beforeUpload,materials,depts } from "@/plugins/common";
import moment from "moment";
import { send } from "process";
export default {
    components: {
        SubTitle,
        ADivider: Divider,
        Modal,
    },
    data() {
        return {
            moment,
            materials,
            depts,
            keyword: "",
            materialName: "",
            deptId:"",
            columns: [/*{
                title: "id",
                width: 50,
                dataIndex: "b_id",
                key: "b_id",
                scopedSlots: { customRender: "showTitle" },
            }*/, {
                    title: "供应商名称",
                    width: 150,
                    dataIndex: "a_fullUnitName",
                    key: "a_fullUnitName",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "报装编号",
                    width: 100,
                    dataIndex: "a_bzNo",
                    key: "a_bzNo",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "工程项目名称",
                    width: 250,
                    dataIndex: "a_projectName",
                    key: "a_projectName",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "物料名称",
                    width: 150,
                    dataIndex: "a_materialName",
                    key: "a_materialName",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "型号规格",
                    width: 150,
                    dataIndex: "a_model",
                    key: "a_model",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "数量",
                    width: 70,
                    dataIndex: "a_num",
                    key: "a_num",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "单位",
                    width: 70,
                    dataIndex: "a_unit",
                    key: "a_unit",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "状态",
                    width: 70,
                    dataIndex: "b_status",
                    key: "b_status",
                    scopedSlots: { customRender: "showStatus" },
                },
                {
                    title: "检测机构",
                    width: 70,
                    dataIndex: "deptName",
                    key: "deptName",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "记录人",
                    width: 90,
                    dataIndex: "a_userName",
                    key: "a_userName",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "操作时间",
                    width: 120,
                    dataIndex: "b_checked_at",
                    key: "b_checked_at",
                    scopedSlots: { customRender: "showTitle" },
                },
                {
                    title: "操作",
                    key: "operation",
                    width: 240,
                    scopedSlots: { customRender: "operation" },
                }],
            list: [],
            pagination: {
                total: 0,
                current: 1,
                showTotal: (total) => {
                    return `共 ${total} 条`;
                },
            },
            queryParams: {
                limit: 10,
                page: 0,
                searchCondition: {
                    flag: 9528,
                    assign:1
                },
            },
            loading: false,
            selectTab: '9528',
            tabTitle1: "送样管理",
            tabTitle2: "检测管理",
            tabTitle3: "报告管理",

            selectedRowKeys: [],
            expandedRowKeys: [],
            deling: false,

            user: {},


            // 送样管理
            edit_visible: false,

            // 检测管理
            edit_visible2: false,

            testObj: {},

            check_methods: ["到货视频抽检", "现场视频抽检"],
            check_results: [{ title: "合格", "value": 1 }, { title: "不合格", "value": 2 }],

            fileList: [],
            fileList2: [],
            params: {},
        }
    },
    beforeCreate() {
        console.log("beforeCreate");
        this.form = this.$form.createForm(this);
    },
    mounted() {
        this.user = getUserInfo();
        // this.queryParams.searchCondition.flag = this.user.dept_id != 134?9528:9527;
        // this.selectTab = this.user.dept_id != 134?'9528':'9527';
        this.queryParams.searchCondition.flag = 9528;
        this.selectTab = '9528';
        this.testObj = {
            receiver: this.user.cname
        };
        this.getList();
    },
    methods: {
        beforeUpload,
        getList(flag) {
            if (this.loading) return;
            this.loading = true;
            if (flag == true) {
                this.pagination.current = 1;
            }
            this.queryParams.page = this.pagination.current - 1;

            if (this.keyword) {
                this.queryParams.searchCondition.keyword = this.keyword;
            } else {
                delete this.queryParams.searchCondition.keyword;
            }
            if (this.materialName) {
                this.queryParams.searchCondition.materialName = this.materialName;
            } else {
                delete this.queryParams.searchCondition.materialName;
            }
            if (this.deptId) {
                this.queryParams.searchCondition.deptId = this.deptId;
            } else {
                delete this.queryParams.searchCondition.deptId;
            }
            get_check_list(this.queryParams)
                .then((res) => {
                    console.log(res);
                    this.list = res.list;
                    this.pagination.total = res.total;
                    this.showTabTitle();
                })
                .finally((res) => {
                    this.loading = false;
                });
        },
        onPageChange(pagination, filters, sorter) {
            this.expandedRowKeys = [];
            this.pagination = pagination;
            this.queryParams.page = pagination.current - 1;
            this.getList();
        },
        reset() {// clear conditions
            this.keyword = "";
            this.materialName = "";
            this.deptId = "";
            this.pagination.current = 1;
            this.queryParams.page = 0;
            this.selectedRowKeys = [];
            this.expandedRowKeys = [];
            this.edit_visible = false;
            this.edit_visible2 = false;
            this.testObj = {
                receiver: this.user.cname
            };
            this.fileList = [];
            this.fileList2 = [];
            this.params = {};
            this.getList();
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        expandAll() {
            if (this.expandedRowKeys.length == 0) {
                this.list.forEach((item, index) => {
                    this.expandedRowKeys.push(item.b_id);
                });
            } else {
                this.expandedRowKeys = [];
            }
        },
        rowClass(record) {
            // console.log(record.b_status);
            if (record.b_status == 1) {
                return "checkClass";
            } else if (record.b_status == 2) {
                return "coverClass";
            } else {
                return "";
            }
        },
        rowClass2(record) {
            // console.log(record.b_status);
            if (record.b_check_result == 1) {
                return "checkSuccessClass";
            } else if (record.b_check_result == 2) {
                return "checkFailedClass";
            } else {
                return "";
            }
        },
        getStatus(b_status) {
            if (b_status == 1) {
                return "抽检";
            } else if (b_status == 2) {
                return "覆盖";
            } else {
                return "初始";
            }
        },
        expandMe(expanded, record) {
            console.log(expanded + "~" + record);
            console.log(this.expandedRowKeys);
            if (!expanded) {
                let idx = this.expandedRowKeys.indexOf(record.b_id);
                this.expandedRowKeys.splice(idx, 1);
            } else {
                this.expandedRowKeys.push(record.b_id);
            }
            console.log(this.expandedRowKeys);
        },
        callback(key) {
            this.selectTab = key;
            // console.log(key);
            this.queryParams.searchCondition.flag = key;

            this.reset();
        },
        showTabTitle() {
            if (this.selectTab == '9528') {
                this.tabTitle1 = "送样管理（" + this.pagination.total + "）";
                this.tabTitle2 = "检测管理";
                this.tabTitle3 = "报告管理";
            } else if (this.selectTab == '9527') {
                this.tabTitle1 = "送样管理";
                this.tabTitle2 = "检测管理（" + this.pagination.total + "）";
                this.tabTitle3 = "报告管理";
            } else if (this.selectTab == '9529') {
                this.tabTitle1 = "送样管理";
                this.tabTitle2 = "检测管理";
                this.tabTitle3 = "报告管理（" + this.pagination.total + "）";
            }
        },
        // 送样管理
        checkOne(flag, obj) {
            // this.$message.warning("填报");
            this.testObj = obj;
            if (!this.testObj.receiver) {
                this.testObj.receiver = this.user.cname;
            }
            console.log(this.testObj);
            if (flag == 1) {
                this.edit_visible = true;
            } else {
                this.edit_visible2 = true;
            }
        },
        save_handle() {
            // this.$message.success("送样保存");
            var self = this;
            let url1 = self.getUrl();
            if (!url1 || '[]' == url1) {
                this.$message.warning("请上传收样照片！");
                return;
            }
            self.form.validateFields((err, values) => {
                console.log(values);
                self.$set(values, "received_url", url1);
                if (!err) {
                    if (self.submitting) return;
                    self.submitting = true;
                    let testObj = {
                        id: values.id,
                        received_at: values.received_at.format("YYYY-MM-DD HH:mm:ss"),
                        receiver: values.receiver,
                        receiver_id: this.user.id,
                        check_method: values.check_method,
                        checker: values.checker,
                        received_url: values.received_url,
                        assignHN:values.assignHN?1:0
                    };
                    sendInvoice(testObj).then(function (data) {
                        self.$message.success("送样成功！");
                        self.reset();
                    }).finally(function () {
                        self.submitting = false;
                    });

                }
            });
        },
        save_handle2() {
            // this.$message.success("报告保存");
            var self = this;
            let url1 = self.getUrl2();
            if (!url1 || '[]' == url1) {
                this.$message.warning("请上传检测报告！");
                return;
            }
            self.form.validateFields((err, values) => {
                console.log(values);
                self.$set(values, "report_url", url1);
                if (!err) {
                    if (self.submitting) return;
                    self.submitting = true;
                    let testObj = {
                        id: values.id,
                        check_time: values.check_time.format("YYYY-MM-DD HH:mm:ss"),
                        report_url: values.report_url,
                        check_result: values.check_result,
                        report_remark: values.report_remark,
                        reporter_id: this.user.id,
                        reporter: this.user.cname,
                        report_no: values.report_no
                    };
                    reportInvoice(testObj).then(function (data) {
                        self.$message.success("报告成功！");
                        self.reset();
                    }).finally(function () {
                        self.submitting = false;
                    });

                }
            });
        },

        handleChange(info) {
            console.log(info.file.status);
            let fileList = [...info.fileList];

            fileList = fileList.map((file) => {
                if (file.response) {
                    // console.log(file);
                    file.url = file.response.data.url;
                    // file.name = "";
                }
                return file;
            });
            this.fileList = fileList;
            // console.log(this.fileList);
        },
        getUrl() {
            let urls = [];
            for (let file of this.fileList) {
                console.log(file);
                if (file.status == "done") {
                    urls.push(file.url);
                }
            }
            return JSON.stringify(urls);
        },
        handleChange2(info) {
            console.log(info.file.status);
            let fileList = [...info.fileList];

            fileList = fileList.map((file) => {
                if (file.response) {
                    // console.log(file);
                    file.url = file.response.data.url;
                    // file.name = "";
                }
                return file;
            });
            this.fileList2 = fileList;
            // console.log(this.fileList);
        },
        getUrl2() {
            let urls = [];
            for (let file of this.fileList2) {
                console.log(file);
                if (file.status == "done") {
                    urls.push(file.url);
                }
            }
            return JSON.stringify(urls);
        },

        getUrls(urls) {
            if (urls) {
                return JSON.parse(urls);
            }
            return [];
        },
        exportData() {
            if (this.loading) return;
            this.loading = true;
            this.queryParams.page = this.pagination.current - 1;

            if (this.keyword) {
                this.queryParams.searchCondition.keyword = this.keyword;
            } else {
                delete this.queryParams.searchCondition.keyword;
            }
            if (this.materialName) {
                this.queryParams.searchCondition.materialName = this.materialName;
            } else {
                delete this.queryParams.searchCondition.materialName;
            }
            if (this.deptId) {
                this.queryParams.searchCondition.deptId = this.deptId;
            } else {
                delete this.queryParams.searchCondition.deptId;
            }
            if( this.queryParams.searchCondition.flag == 9527 || this.queryParams.searchCondition.flag == 9529 ) {
                this.queryParams.searchCondition.full = 1;
            } else {
                delete this.queryParams.searchCondition.full;
            }
            exportData(this.queryParams)
                .then((res) => {
                    console.log(res);
                    window.open(res);
                })
                .finally((res) => {
                    this.loading = false;
                });
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/style.scss";

.other-filter {
    display: flex;
    height: 50px;
    align-items: center;

    .mr-20 {
        margin-right: 20px;
    }
}

.childCss {
    font-size: 14px;
}
</style>

<style>
.checkClass {
    color: orange;
}

.coverClass {
    color: blue;
}

.checkSuccessClass {
    color: green;
}

.checkFailedClass {
    color: red;
}
</style>